import * as React from 'react';
import {BlockContext} from '../../BlockContext';
import {ContextProviderProps} from '../../types';

/**
 * The hook give access to props of the current block.
 * @return {ContextProviderProps['value']}
 */
export default function useBlockContext(): ContextProviderProps['value'] {
  const context = React.useContext(BlockContext);

  if (context === undefined) {
    throw new Error('useBlockContext must be used within a BlockContext');
  }

  return context;
}
